module.exports = __webpack_public_path__ + "img/18_38.4162c2a4.png";